<rate-app (rate)="onRate()" (cancel)="onCancel()"></rate-app>
